import React from 'react'
import { Edit2, Trash2, Package } from 'lucide-react'
import { formatCurrency, formatDate } from '../../utils/formatters'
import { calculateRemainingStock } from '../../utils/calculations'
import './ProductTable.scss'

const ProductTable = ({
  products,
  purchases,
  onEdit,
  onDelete,
  onImageClick,
}) => {
  return (
    <div className='overflow-x-auto'>
      <table className='table'>
        <thead>
          <tr>
            <th>Image</th>
            <th>Produit</th>
            <th>Code</th>
            <th>Taille</th>
            <th>Couleur</th>
            <th>Prix</th>
            <th>Stock</th>
            <th>Date d'ajout</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) => {
            const remainingStock = calculateRemainingStock(product, purchases)
            return (
              <tr key={product.id}>
                <td>
                  {product.images && product.images.length > 0 ? (
                    <div className='table-product-image'>
                      <img
                        src={product.images[0]}
                        alt={product.name}
                        onClick={() => onImageClick(product.images)}
                        className='clickable-image'
                      />
                      {product.images.length > 1 && (
                        <span className='image-count-small'>
                          +{product.images.length - 1}
                        </span>
                      )}
                    </div>
                  ) : (
                    <div className='no-image-placeholder'>
                      <Package size={20} />
                    </div>
                  )}
                </td>
                <td>
                  <div className='cell-content'>
                    <div className='primary-text'>
                      {product.name.length > 15
                        ? product.name.substring(0, 15) + '...'
                        : product.name}
                    </div>
                  </div>
                </td>
                <td>
                  <span className='text-sm font-medium'>{product.code}</span>
                </td>
                <td>
                  <span className='text-sm'>{product.size || '-'}</span>
                </td>
                <td>
                  <span className='text-sm'>{product.color || '-'}</span>
                </td>
                <td>
                  <span className='font-bold'>
                    {formatCurrency(product.basePrice)}
                  </span>
                </td>
                <td>
                  <div className='stock-cell'>
                    <span
                      className={`stock-value ${
                        remainingStock < 2 && remainingStock >= 0
                          ? 'stock-warning'
                          : remainingStock < 0
                            ? 'stock-critical'
                            : ''
                      }`}
                    >
                      {remainingStock}
                    </span>
                    {remainingStock < 2 && remainingStock >= 0 && (
                      <span className='stock-indicator warning'>Faible</span>
                    )}
                    {remainingStock < 0 && (
                      <span className='stock-indicator critical'>Rupture</span>
                    )}
                  </div>
                </td>
                <td>
                  <span className='text-sm'>
                    {formatDate(product.createdAt)}
                  </span>
                </td>
                <td>
                  <div className='action-buttons'>
                    <button
                      style={{ width: '100%' }}
                      onClick={() => onEdit(product)}
                      className='btn secondary sm'
                    >
                      <Edit2 size={14} className='btn-icon' />
                      Modifier
                    </button>
                    <button
                      style={{ width: '100%' }}
                      onClick={() => onDelete(product)}
                      className='btn danger sm'
                    >
                      <Trash2 size={14} className='btn-icon' />
                      Supprimer
                    </button>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default ProductTable
